import { brand } from "../../../context";

export type StatusTagProps = {
  hasOffer: boolean;
  status: "SE" | "DR" | "RJ" | "AC";
  statusDisplay: string;
};

export function StatusTag({ hasOffer, status, statusDisplay }: StatusTagProps) {
  let backgroundClass = "bg-gray-200";
  let textColorClass = "text-gray-900";

  if (hasOffer) {
    backgroundClass = "bg-orange-500";
    textColorClass = "text-white";
  } else if (status === "SE") {
    backgroundClass = "bg-green-500";
    textColorClass = "text-white";
  } else if (status === "AC") {
    backgroundClass = "bg-blue-500";
    textColorClass = "text-gray-100";
  } else if (status === "DR") {
    backgroundClass = "bg-amber-500";
    textColorClass = "text-gray-900";
  } else if (status === "RJ") {
    backgroundClass = "bg-red-500";
    textColorClass = "text-white";
  }

  return (
    <span
      className={`inline-flex items-center rounded px-2 py-0.5 text-xs font-medium ${backgroundClass} ${textColorClass}`}
    >
      {hasOffer ? "Offer Available" : statusDisplay}
    </span>
  );
}

export type ViewOfferButtonProps = {
  offerReference: string;
};

export function ViewOfferButton({ offerReference }: ViewOfferButtonProps) {
  const url = `https://travelcompanion.easytravel.tech/trip_info/REF__${offerReference}`;
  return (
    <button
      type="button"
      className="Button text-xs! p-1!"
      data-brand={brand}
      onClick={() => {
        window.open(url, "_blank") || window.location.replace(url);
      }}
    >
      View Offer
    </button>
  );
}
